import React from 'react';
import { Box, Typography, Grid, Link, Paper, Divider } from '@mui/material';
import { t } from 'i18next'; // Import localization function

const ContactPage = () => {
  const now = new Date();
  const currentHour = now.getHours();
  const currentDay = now.getDay(); // 0 is Sunday, 6 is Saturday
  const isWeekend = currentDay === 0 || currentDay === 6;
  const isAfterHours = currentHour >= 16 || currentHour < 6 || isWeekend;
  
  const phoneNumber = isAfterHours ? "+358505440889" : "010 200 5000";
  
  return (
    <Box sx={{ padding: '32px', maxWidth: '1200px', marginBottom: '50px' }}>
      <Typography 
        variant="h4" 
        fontWeight="bold" 
        mb={4}
        sx={{ 
          color: '#1a365d',
          borderBottom: '2px solid #e2e8f0',
          paddingBottom: '12px'
        }}
      >
        {t('contactPage.title')}
      </Typography>
      
      <Grid container spacing={4}>
        {/* Customer Service Section */}
        <Grid item xs={12} md={6}>
          <Paper 
            elevation={2} 
            sx={{ 
              padding: '24px', 
              height: '100%',
              borderRadius: '8px',
              transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
              }
            }}
          >
            <Typography 
              variant="h6" 
              fontWeight="bold"
              sx={{ 
                color: '#2c5282',
                marginBottom: '16px'
              }}
            >
              {t('contactPage.customerService')}
            </Typography>
            
            <Divider sx={{ marginBottom: '16px' }} />
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Typography variant="body1" fontWeight="medium" sx={{ minWidth: '100px' }}>
                  {t('contactPage.phone')}:
                </Typography>
                <Link 
                  href={`tel:${phoneNumber}`}
                  sx={{ 
                    color: '#3182ce',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  {phoneNumber} 
                  {isAfterHours && (
                    <Typography 
                      component="span" 
                      sx={{ 
                        fontSize: '0.85rem', 
                        color: '#718096',
                        ml: 1
                      }}
                    >
                      (maksullinen numero - aukioloaikojen ulkopuolella)
                    </Typography>
                  )}
                </Link>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Typography variant="body1" fontWeight="medium" sx={{ minWidth: '100px' }}>
                  {t('contactPage.email')}:
                </Typography>
                <Link 
                  href="mailto:info@myxline.fi"
                  sx={{ 
                    color: '#3182ce',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  info@myxline.fi
                </Link>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Typography variant="body1" fontWeight="medium" sx={{ minWidth: '100px' }}>
                  {t('contactPage.openHours')}:
                </Typography>
                <Typography variant="body1">
                  {t('contactPage.openHoursDetails')}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactPage;